import { Injectable } from '@angular/core';
import { EventDetail } from '../_interfaces/eventDetail';
import { AssignmentFormatter } from './formatters/assignment-formatter';
import { SkillAssignmentFormatter } from './formatters/skill-assignement-formatter';
import { GenericDiffFormatter } from './formatters/generic-diff-formatter';
import { IEventFormatter } from './formatters/ievent-formatter';

@Injectable({
  providedIn: 'root'
})
export class EventFormatterService {

  private formatters = new Map<string, IEventFormatter>();
  private genericFormatter = new GenericDiffFormatter();

  constructor() {
    const assignmentFormatter = new AssignmentFormatter();
    const skillAssignmentFormatter = new SkillAssignmentFormatter();

    this.formatters.set('People.team.assignment', assignmentFormatter);
    this.formatters.set('People.team.unassignment', assignmentFormatter);
    this.formatters.set('People.team.assignment.update', assignmentFormatter);
    this.formatters.set('Team.person.add', assignmentFormatter);
    this.formatters.set('Team.person.remove', assignmentFormatter);
    this.formatters.set('Team.person.assignment.update', assignmentFormatter);
    this.formatters.set('Team.skill.edit', skillAssignmentFormatter);
  }

  /**
   * Formats an event's properties into a human-readable array of messages.
   * It uses a specific formatter based on the event type_id, or a generic one as a fallback.
   * @param properties The 'properties' object from the Event API response.
   * @param type_id The type of the event (e.g., 'People.team.assignment').
   * @returns An array of EventDetail objects with translation keys and parameters.
   */
  public formatEventDetails(properties: any, type_id: string): EventDetail[] {
    const formatter = this.formatters.get(type_id);

    if (formatter) {
      return formatter.format(properties, type_id);
    }

    // Fallback for old-style diff events
    if (properties && properties.changes) {
      return this.genericFormatter.format(properties, type_id);
    }

    // Default fallback for unknown events
    return [{
      key: 'EVENTS.CHANGE.UNKNOWN',
      params: {}
    }];
  }
}
